import {
  Table,
  Header,
  Form,
  Checkbox,
  Button,
  Icon,
  Message,
  Input,
} from 'semantic-ui-react';
import {
  isEmpty, get, map, find,
} from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Validator from 'validatorjs';

class FlatRatesList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedflatRates: [],
      dealerPhone: null,
      dealerName: null,
      dealerEmail: null,
      salesRepEmail: null,
      userEmail: null,
      auctionAccessNumber: null,
      flatRates: null,
      flatRatesValidate: null,
      milesSelected: null,
      psiEligible: false,
      palv: false,
      daysPsi: null,
      daysSelected: null,
      errors: {},
      dealers: null,
      productId: null,
      productType: null,
      productName: null,
    };
  }

  componentDidMount() {
    const {
      flatRates,
      auctionAccessNumber,
      milesSelected,
      psiEligible,
      palv,
      daysSelected,
      buyerInformation: { name, cellPhone, emails },
      dealers,
      govtLast4,
      daysPsi,
      productId,
      productType,
      productName,
    } = this.props;

    this.setState({
      flatRates,
      auctionAccessNumber,
      govtLast4,
      milesSelected,
      psiEligible,
      palv,
      daysSelected,
      dealerPhone: cellPhone,
      dealerName: name,
      dealerEmail: emails,
      dealers,
      daysPsi,
      productId,
      productType,
      productName,
    });
  }

  generateFlatRateBySelected() {
    const { selectedflatRates, flatRates } = this.state;
    const flatRatesValidate = flatRates.filter(rate => selectedflatRates.includes(rate.dealerNo));
    this.setState({
      flatRatesValidate,
    });
  }

  render() {
    const {
      onSubmitHandler,
      error,
    } = this.props;

    const {
      selectedflatRates,
      flatRates,
      flatRatesValidate,
      errors,
      daysPsi,
      milesSelected,
      psiEligible,
      dealers,
      dealerName,
      dealerEmail,
      dealerPhone,
      userEmail,
      salesRepEmail,
    } = this.state;

    const onRateCheckboxHandler = () => (event, data) => {
      let currentSelected = [...selectedflatRates];

      if (data.checked) {
        currentSelected.push(data.value);
      } else {
        currentSelected = currentSelected.filter(
          selected => selected !== data.value
        );
      }
      this.setState({ selectedflatRates: currentSelected });
    };

    const onChangeHandler = field => event => {
      this.setState({ [field]: event.target.value });
    };

    const onChangeTargetPriceHandler = field => event => {
      this.setState(prevState => {
        const currentFlatRates = Object.assign([], prevState.flatRates);
        const flatRate = { ...find(currentFlatRates, ['dealerNo', field]) };
        const index = currentFlatRates.indexOf(find(currentFlatRates, ['dealerNo', field]));
        flatRate.targetPrice = event.target.value;
        currentFlatRates[index] = flatRate;
        return { flatRates: currentFlatRates };
      });
    };

    const onChangeBundlePriceHandler = field => event => {
      this.setState(prevState => {
        const currentFlatRates = Object.assign([], prevState.flatRates);
        const flatRate = { ...find(currentFlatRates, ['dealerNo', field]) };
        const index = currentFlatRates.indexOf(find(currentFlatRates, ['dealerNo', field]));
        flatRate.psiBundlePrice = event.target.value;
        currentFlatRates[index] = flatRate;
        return { flatRates: currentFlatRates };
      });
    };
    const emailPattern = /^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[a-zA-Z]{2,}$/;
    Validator.register(
      'emails_list_check',
      value => {
        const emailList = value.split(',').map(email => email.trim());
        return emailList.every(email => email.length > 0 && emailPattern.test(email));
      },
      'The :attribute must valid.'
    );
    const validationRules = {
      userEmail: 'required|emails_list_check',
      salesRepEmail: 'required|emails_list_check',
      dealerEmail: 'required|email',
      dealerName: 'required',
      'flatRatesValidate.*.targetPrice': 'required|numeric',
      'flatRatesValidate.*.psiBundlePrice': 'required|numeric',
    };
    const customErrorMessage = {
      numeric: 'Invalid format number',
      required: 'This field is required',
    };
    const submitForm = async() => {
      this.setState({ errors: {} });
      await this.generateFlatRateBySelected();
      const {
        auctionAccessNumber,
        govtLast4,
        userEmail: stateUserEmail,
        salesRepEmail: stateSalesRepEmail,
        dealerPhone: stateDealerPhone,
        dealerName: stateDealerName,
        dealerEmail: stateDealerEmail,
        flatRates: stateFlatRates,
        selectedflatRates: stateSelectedFlatRates,
        milesSelected: stateMilesSelected,
        psiEligible: statePsiEligible,
        palv,
        daysSelected,
        daysPsi: stateDaysPsi,
        productId,
        productType,
        productName,
      } = this.state;

      if (stateDaysPsi) {
        validationRules['flatRatesValidate.*.psiBundlePrice'] = 'required|numeric';
      } else {
        delete validationRules['flatRatesValidate.*.psiBundlePrice'];
      }

      const validation = new Validator(
        this.state,
        validationRules,
        customErrorMessage
      );

      if (validation.fails()) {
        this.setState({ errors: validation.errors.all() });
        return false;
      }
      const flatRateOffers = stateSelectedFlatRates.map(dealerNo => {
        const flatRate = find(stateFlatRates, ['dealerNo', dealerNo]);
        return {
          flatRateId: flatRate.id,
          dealerNo: parseInt(dealerNo, 10),
          price: parseFloat(flatRate.targetPrice),
          psiBundlePrice: parseFloat(flatRate.psiBundlePrice),
          milesSelected: stateMilesSelected,
          psiEligible: statePsiEligible,
          daysPsi: stateDaysPsi,
          palv,
          daysSelected,
          productId,
          productType,
          productName,
          exceptionsProductName:
              stateMilesSelected < 360 ? 'purchaseprotect' : 'extendedprotect',
        };
      });

      onSubmitHandler({
        auctionAccessNumber: auctionAccessNumber.trim(),
        govtLast4,
        userEmail: stateUserEmail,
        salesRepEmail: stateSalesRepEmail,
        buyerInformation: {
          name: stateDealerName,
          emails: stateDealerEmail,
          cellPhone: stateDealerPhone,
        },
        flatRateOffers,
      });
      this.setState({ errors: {} });
      return true;
    };

    return (
      <Form>
        <br />
        <hr />
        <br />
        <Header>Automatic DealShield Offer Generator</Header>
        <br />
        {psiEligible && (
          <div>Dealshield Offer Parameter: {milesSelected} Miles & PSI</div>
        )}
        {!psiEligible && (
          <div>Dealshield Offer Parameter: {milesSelected} Miles</div>
        )}
        <br />
        <br />
        Below is the suggested pricing for the dealers you have selected. Please
        review and provide a final amount to be offered to the dealer.
        <br />
        For any questions please contact automatic@dealshield.com
        <br />
        <Table celled padded size='small'>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell singleLine textAlign='center'>
                Select Dealers/Price.
              </Table.HeaderCell>
              <Table.HeaderCell>Dealer Information</Table.HeaderCell>
              <Table.HeaderCell>DealShield Price</Table.HeaderCell>
              <Table.HeaderCell>PSI Bundle Price</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {map(flatRates, flatRate => {
              const indexError = !isEmpty(flatRatesValidate)
                ? flatRatesValidate.findIndex(
                  f => f.dealerNo === flatRate.dealerNo
                )
                : -1;
              return (
                <Table.Row key={flatRate.id}>
                  <Table.Cell textAlign='center'>
                    <Checkbox
                      value={flatRate.dealerNo}
                      checked={get(
                        selectedflatRates,
                        flatRate.dealerNo
                      )}
                      onChange={onRateCheckboxHandler('selectedflatRates')}
                    />
                    <br />
                    {flatRate.ineligibilityReason}
                  </Table.Cell>
                  <Table.Cell>
                    {flatRate.dealerNo
                      + ' - '
                      + find(dealers, ['id', flatRate.dealerNo]).name}
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field
                      required
                      error={
                        !isEmpty(
                          errors[`flatRatesValidate.${indexError}.targetPrice`]
                        )
                      }
                    >
                      <Input
                        name='targetPrice'
                        value={flatRate.targetPrice}
                        onChange={onChangeTargetPriceHandler(flatRate.dealerNo)}
                      />
                      {errors[
                        `flatRatesValidate.${indexError}.targetPrice`
                      ] && (
                        <span style={{ color: 'red' }}>
                          {
                            errors[
                              `flatRatesValidate.${indexError}.targetPrice`
                            ]
                          }
                        </span>
                      )}
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field
                      required
                      error={
                        !isEmpty(
                          errors[
                            `flatRatesValidate.${indexError}.psiBundlePrice`
                          ]
                        )
                      }
                    >
                      <Input
                        name='psiBundlePrice'
                        value={flatRate.psiBundlePrice}
                        disabled={!daysPsi}
                        onChange={onChangeBundlePriceHandler(flatRate.dealerNo)}
                      />
                      {errors[
                        `flatRatesValidate.${indexError}.psiBundlePrice`
                      ] && (
                        <span style={{ color: 'red' }}>
                          {
                            errors[
                              `flatRatesValidate.${indexError}.psiBundlePrice`
                            ]
                          }
                        </span>
                      )}
                    </Form.Field>
                  </Table.Cell>
                </Table.Row>
              );
            })}
          </Table.Body>
        </Table>
        Default price is imported from standard pricing file.
        <br /> Final offer price may be edited at discretion or, for example, to
        override a custom group rate for individual dealerships.
        {!isEmpty(selectedflatRates) && (
          <div>
            <br />
            <hr />
            <br />
            {error && (
              <Message negative>
                <p>{error}</p>
              </Message>
            )}
            <br />
            <Header>Confirm Automatic DealShield Offer</Header>
            <br />
            <br />
            Please review and confirm the information below regarding the offer
            you are requesting.
            <br />
            <br />
            <Form.Group widths='equal'>
              <Form.Field required error={!isEmpty(errors.dealerName)}>
                <label htmlFor='dealerName'>Dealer Name</label>
                <Input
                  id='dealerName'
                  placeholder='Dealer Name'
                  name='dealerName'
                  value={dealerName}
                  onChange={onChangeHandler('dealerName')}
                />
                {errors.dealerName && <span>{errors.dealerName}</span>}
              </Form.Field>
              <Form.Field required error={!isEmpty(errors.dealerEmail)}>
                <label htmlFor='dealerEmail'>Dealer Email</label>
                <Input
                  id='dealerEmail'
                  placeholder='Dealer Email'
                  name='dealerEmail'
                  value={dealerEmail}
                  onChange={onChangeHandler('dealerEmail')}
                />
                {errors.dealerEmail && <span>{errors.dealerEmail}</span>}
              </Form.Field>
              <Form.Field required>
                <label htmlFor='dealerPhone'>Dealer Phone#</label>
                <Input
                  id='dealerPhone'
                  placeholder='Dealer Phone#'
                  name='dealerPhone'
                  value={dealerPhone}
                  onChange={onChangeHandler('dealerPhone')}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group widths='equal'>
              <Form.Field required error={!isEmpty(errors.userEmail)}>
                <label htmlFor='userEmail'>
                  Please provide an email address to receive updates on this
                  offer.
                </label>
                <Input
                  id='userEmail'
                  placeholder='User Email'
                  name='userEmail'
                  value={userEmail}
                  onChange={onChangeHandler('userEmail')}
                />
                {errors.userEmail && <span>{errors.userEmail}</span>}
              </Form.Field>
              <Form.Field required error={!isEmpty(errors.salesRepEmail)}>
                <label htmlFor='salesRepEmail'>Sales Rep Email</label>
                <Input
                  id='salesRepEmail'
                  placeholder='Sales Rep Email'
                  name='salesRepEmail'
                  value={salesRepEmail}
                  onChange={onChangeHandler('salesRepEmail')}
                />
                {errors.salesRepEmail && <span>{errors.salesRepEmail}</span>}
              </Form.Field>
            </Form.Group>
            <br />
            <br />
            <Form.Group>
              <Form.Field>
                <Button color='green' onClick={submitForm} inverted>
                  <Icon name='checkmark' /> Create
                </Button>
              </Form.Field>
            </Form.Group>
          </div>
        )}
      </Form>
    );
  }
}

FlatRatesList.propTypes = {
  flatRates: PropTypes.array,
  auctionAccessNumber: PropTypes.string,
  milesSelected: PropTypes.number,
  psiEligible: PropTypes.bool,
  palv: PropTypes.bool,
  daysSelected: PropTypes.number,
  buyerInformation: PropTypes.shape({
    name: PropTypes.string,
    cellPhone: PropTypes.string,
    emails: PropTypes.string,
  }),
  dealers: PropTypes.array,
  govtLast4: PropTypes.string,
  daysPsi: PropTypes.number,
  productId: PropTypes.number,
  productType: PropTypes.string,
  productName: PropTypes.string,
  onSubmitHandler: PropTypes.func,
  error: PropTypes.string,
};

export default FlatRatesList;
